// @ts-nocheck

import colors from "assets/theme/base/colors";
import borders from "assets/theme/base/borders";

const { transparent } = colors;
const { borderRadius } = borders;

const accordion = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      borderRadius: borderRadius.md,
      boxShadow: "none",

      "&:before": {
        display: "none",
      },
    },
  },
};

export default accordion;
